import DOMPurify from "isomorphic-dompurify";
import React from "react";
require("styles/components/common/page-title.scss");

const PageTitle = (data) => {
  console.log(data)
  console.log('PageTitle');
  const renderHTML = rawHTML => React.createElement("div", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(rawHTML) } });

  return (
    <header className="page-title">
      <div className="container">
        <div className="row">
          <div className="col-12 col-title">
            { renderHTML(data?.data?.entity?.body?.[0]?.summary) }
          </div>
        </div>
      </div>
    </header>
  );
}

export default PageTitle;